import { render, staticRenderFns } from "./account-access.vue?vue&type=template&id=1867a3c8&scoped=true"
import script from "./account-access.vue?vue&type=script&lang=js"
export * from "./account-access.vue?vue&type=script&lang=js"
import style0 from "./account-access.vue?vue&type=style&index=0&id=1867a3c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1867a3c8",
  null
  
)

export default component.exports